import React from 'react';
import { LanguageContext } from '@/contexts/language-context';
import i18next from '@/i18next';
import { toast } from 'sonner';
import { useAuthenticationState } from '@/hooks/use-authentication';
export const LanguageProvider = ({ children }) => {
    const [locale, setLocale] = React.useState('en');
    const { user, status } = useAuthenticationState();
    const updateLocale = React.useCallback((locale) => {
        i18next
            .changeLanguage(locale)
            .then(() => {
            setLocale(locale);
        })
            .catch((error) => {
            toast.error(error.message);
        });
    }, []);
    React.useEffect(() => {
        if (status === 'authenticated' && user) {
            updateLocale(user.locale || 'en');
        }
    }, [user, updateLocale, status]);
    return <LanguageContext.Provider value={{ locale, updateLocale }}>{children}</LanguageContext.Provider>;
};
